let defaulsettings = {
    loop: true,
    speed: 900,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    pagination: {
        enabled: false
    },
    navigation: {
        enabled: false
    },
    on: {
        init: function (currentSwiper) {
            swiperADAduplicatedProcess(currentSwiper);
        },
    },
    breakpoints: {
        767: {
            allowTouchMove: false,
        },
    }
};

const autoplayOnlyForImages = {
    delay: 3000
};

const autoplayWithTextContent = {
    delay: 12000,
    disableOnInteraction: false,
   
};

let i = 0;

function swiperADAduplicatedProcess(currentSwiper){
    currentSwiper.slides.forEach((slide) => {
        if (slide.classList.contains('swiper-slide-duplicate')) {
            slide.setAttribute('aria-hidden', true);
            slide.setAttribute('tabindex', '-1');

            // REMOVE IDs
            slide.querySelectorAll('[id]').forEach((elementWithID) => {
                elementWithID.setAttribute('id', '');
            });

            // SET TABINDEXs -1
            slide.querySelectorAll('a').forEach((elementWithID) => {
                elementWithID.setAttribute('tabindex', '-1');
            });
        }
    });

    currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
        dotInSlide.setAttribute('tabindex', '-1');
    });
};

function buildSwiper(classSwiper = '', settingsSwiper = {}) { 
    if (!classSwiper || classSwiper === '') return false; 
    let swiperInstance; 
    document.querySelectorAll(classSwiper).forEach((slider) => { 
        slider.setAttribute(`data-swiper${i}`, ''); 
        swiperInstance = new Swiper(`[data-swiper${i}]`, settingsSwiper); 

        swiperInstance.on('slideChange', (currentSwiper) => { 
            swiperADAduplicatedProcess(currentSwiper); 
        }); 
    i++;
    }); 
    return swiperInstance; 
}

document.addEventListener('DOMContentLoaded', () => {
    
    /*
        ? DEFAULT CONFIGURATION AND CLASS OF SWIPER - OPEN
    */
    let allSwipper =[];
    document.querySelectorAll('.swiper-slider').forEach((element,x) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${x}`,"");
        let swiper = new Swiper(`[data-swiper-${x}]`, swiperConfig);
        allSwipper[x] = swiper;
        swiper.on('slideChange', (currentSwiper) => {
            swiperADAduplicatedProcess(currentSwiper);
        });
    });
    /*
        ? DEFAULT CONFIGURATION AND CLASS OF SWIPER - CLOSE
    */

    /*
        ? TOP CONTENT HOMEPAGE - OPEN
    */
    const homeTopContentModuleClass = '.swiper-topContent';
    const homeTopContentModuleSettings = {
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        slidesPerView: 1,
        allowTouchMove: false,
        autoplay: autoplayOnlyForImages,
        pagination: {
            el: '.topContent-navigation',
            enabled: true,
            clickable: true
        },
        navigation: {
            enabled: false
        }
    };

    buildSwiper(homeTopContentModuleClass, homeTopContentModuleSettings);
    /*
        ? TOP CONTENT HOMEPAGE - CLOSE
    */

    /*
        ? CAROUSEL - OPEN
    */
    const carouselImagesModuleClass = '.carousel_images';
    let carouselImagesModuleSettings = {};
    const carouselTextModuleClass = '.carousel_text';
    let carouselTextModuleSettings = {};


    if( window.innerWidth > 641 ){
        carouselImagesModuleSettings = {
            speed: 1000,
            slidesPerView: 1.6,
            loop: true,
            allowTouchMove: false,
            autoplay: autoplayWithTextContent,
            pagination: {
                enabled: false
            },
            navigation: {
                nextEl: '.carousel-next-arrow',
                prevEl: '.carousel-prev-arrow'
            },
            centeredSlides: true,
            breakpoints: {
                1500: {
                    slidesPerView: 1.8
                }
            }
        };
        carouselTextModuleSettings = {
            speed: 1100,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            allowTouchMove: false,
            autoplay: autoplayWithTextContent,
            pagination: {
                enabled: false
            },
            navigation: {
                nextEl: '.carousel-next-arrow',
                prevEl: '.carousel-prev-arrow'
            },
            breakpoints: {
                1025: {
                    autoHeight: false
                }
            }
        };
    }else{
        carouselImagesModuleSettings = {
            speed: 900,
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            loop: true,
            allowTouchMove: false,
            autoplay: autoplayWithTextContent,
            pagination: {
                enabled: false
            },
            centeredSlides: true
        };
        carouselTextModuleSettings = {
            speed: 900,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            allowTouchMove: false,
            autoHeight:true,
            autoplay: autoplayWithTextContent,
            pagination: {
                enabled: false
            },
            breakpoints: {
                900: {
                    autoHeight: false
                }
            }
        };
    }

    let swipterImagesCarousel = buildSwiper(carouselImagesModuleClass, carouselImagesModuleSettings);
    let swipterTextCarousel = buildSwiper(carouselTextModuleClass, carouselTextModuleSettings);

    if(swipterImagesCarousel && swipterTextCarousel && window.innerWidth < 641 ){
        // swipterImagesCarousel.controller.control = swipterTextCarousel;
        // swipterTextCarousel.controller.control = swipterImagesCarousel;

        const nextArrow = document.querySelector('.carousel-next-arrow');
        const prevArrow = document.querySelector('.carousel-prev-arrow');

        nextArrow.addEventListener('click', () => {
            swipterImagesCarousel.slideNext();
            swipterTextCarousel.slideNext();
        });

        prevArrow.addEventListener('click', () => {
            swipterImagesCarousel.slidePrev();
            swipterTextCarousel.slidePrev();
        });
    }
    /*
        ? CAROUSEL - CLOSE
    */

    /*
        ? GALLERY - OPEN
    */
    const gallertModuleClass = '.gallery_swiper';
    const galleryModuleSettings = {
        speed: 1050,
        slidesPerView: 1.1,
        allowTouchMove: true,
        spaceBetween: 20,
        loop:true,
        centeredSlides: true,
        autoplay: autoplayOnlyForImages,
        simulateTouch: false,
        pagination: {
            el: '.gallery_swiper-nav',
            enabled: true,
            clickable: true
        },
        navigation: {
            enabled: false
        },
        breakpoints: {
            640: {
                allowTouchMove: false,
                slidesPerView: 3,
                spaceBetween: 26,
                centeredSlides: false
            }
        }
    };

    buildSwiper(gallertModuleClass, galleryModuleSettings);
    /*
        ? GALLERY - CLOSE
    */

    /*
        ? CARDS - OPEN
    */
    const cardsModuleClass = '.cards_swiper';
    const cardsModuleSettings = {
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        allowTouchMove: true,
        // autoplay: autoplayWithTextContent,
        pagination: {
            el: '.cards-navigation',
            enabled: true,
            clickable: true,
            renderBullet: function (index, className) {
                let nav_text = document.querySelector(`article.eachCard[data-iteration="${index}"]`).dataset.title
                return '<span class="' + className + '">' + nav_text + "</span>";
            },
        },
        navigation: {
            enabled: true,
            clickable: true,
            prevEl: '.cards-prev-arrow',
            nextEl: '.cards-next-arrow'
        },
        breakpoints: {
            640: {
                allowTouchMove: false,
            }
        }
    };

    buildSwiper(cardsModuleClass, cardsModuleSettings);
    /*
        ? CARDS - CLOSE
    */

    /*
        ? AMENITIES MOBILE - CLOSE
    */
   const amenitiesClass = '.amenities_swiper';
   const amenitiesSettings = {
        speed: 900,
        slidesPerView: 2,
        loop: true,
        allowTouchMove: true,
        autoplay: autoplayWithTextContent,
        spaceBetween: 20,
        navigation: {
            enabled: true,
            clickable: true,
            prevEl: '.amenities-prev-arrow',
            nextEl: '.amenities-next-arrow'
        },
   };
   buildSwiper(amenitiesClass, amenitiesSettings);
    /*
        ? AMENITIES MOBILE - CLOSE
    */

    /// slider slide
    if(document.querySelectorAll('.slider-block_slider').length > 0){
        const sliderClass = '.slider-block_slider';
        const sliderSettings = {
            speed: 1000,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            allowTouchMove: true,
            autoHeight: true,
            autoplay: autoplayWithTextContent,
            navigation: {
                enabled: true,
                clickable: true,
                prevEl: '.slider-prev-arrow',
                nextEl: '.slider-next-arrow'
            },
            breakpoints: {
                900: {
                    autoHeight: false
                }
            }
       };
       buildSwiper(sliderClass, sliderSettings);
    }
    
});